const flex = (flexParams) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  ...flexParams,
})

export default flex
